export default "__VITE_ASSET__DjTWQLHB__"